export enum Authority {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
  ROLE_MONITORING = 'ROLE_MONITORING',
  ROLE_REPO_MANAGER = 'ROLE_REPO_MANAGER',
  ROLE_CLUSTER = 'ROLE_CLUSTER',
  IS_AUTHENTICATED_FULLY = 'IS_AUTHENTICATED_FULLY',
  SYSTEM_REPO = 'SYSTEM',
  READ_REPO = 'READ_REPO',
  READ_REPO_PREFIX = 'READ_REPO_',
  WRITE_REPO = 'WRITE_REPO',
  GRAPHQL = 'GRAPHQL',
  WRITE_REPO_PREFIX = 'WRITE_REPO_',
  GRAPHQL_PREFIX = 'GRAPHQL_',
  SUFFIX_DELIMITER = ':',
  CUSTOM_PREFIX = 'CUSTOM_'
}

